module.exports = __webpack_public_path__ + "img/task-3-pop.ffce4169.png";